import { X } from "lucide-react";
import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceStatus } from "@intelligems/ig-types";
import { Box, Grid, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { ProductFilters } from "@src/components/MainApp/SharedProductPicker/list/ProductFilters";
import { useDispatch } from "@src/store";
import {
  closeProductPicker,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import {
  GetProductPickerInfo,
  ProductPickerLoadStatus,
} from "@src/store/slices/productPicker/types";

import { ProductSection } from "./list/ProductSection";
import { SelectedProductSection } from "./list/SelectedProductSection";
import { ProductPickerProvider } from "./ProductPickerProvider";
import { ProductsLoadingPleaseWait } from "./ProductsLoadingPleaseWait";
import { SavingProductsPleaseWait } from "./SavingProductsPleaseWait";

interface ProductPickerProps {
  getProductPickerInfo?: GetProductPickerInfo;
  renderLocation?: string;
  isView?: boolean;
  experienceStatus?: ExperienceStatus;
  loadStatus?: ProductPickerLoadStatus;
  loadingCount?: number;
  totalProducts?: number;
  dialogActions?: ReactNode[];
  sx?: SxProps;
  slotProps?: {
    product?: {
      sx?: SxProps;
    };
  };
}

export const ProductPicker = ({
  getProductPickerInfo,
  isView,
  experienceStatus,
  loadStatus,
  loadingCount,
  totalProducts,
  dialogActions,
  sx,
  slotProps,
  renderLocation,
}: ProductPickerProps) => {
  const theme = useTheme();
  const products = useSelector(getProductPickerSelectedProducts);
  const dispatch = useDispatch();
  return (
    <ProductPickerProvider allowIgProducts={renderLocation === "customEvents"}>
      <Grid
        container
        direction={"column"}
        sx={{
          border: `1px solid ${theme.igBorders.core.default}`,
          borderRadius: "8px",
        }}
      >
        {loadStatus === "saving" && <SavingProductsPleaseWait />}
        {loadStatus === "loading" && (
          <ProductsLoadingPleaseWait
            loadingCount={loadingCount}
            totalProducts={totalProducts}
          />
        )}
        {loadStatus === undefined && (
          <>
            <Grid
              item
              container
              direction={"row"}
              padding={6}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{
                borderBottom: `1px solid ${theme.igBorders.core.default}`,
              }}
            >
              <Grid item>
                <IgTypography variant={"h3"} fontWeight={600}>
                  Select products
                </IgTypography>
              </Grid>
              <Grid item sx={{ height: "24px", width: "24px" }}>
                <IgIconButton
                  onClick={() => {
                    dispatch(closeProductPicker());
                  }}
                >
                  <X size={18} />
                </IgIconButton>
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction={"row"}
              wrap={"nowrap"}
              sx={{ height: "460px" }}
            >
              <Grid
                item
                sx={{
                  borderRight: `1px solid ${theme.igBorders.core.default}`,
                }}
              >
                <ProductFilters
                  allowIgProducts={renderLocation === "customEvents"}
                />
              </Grid>
              <Grid item sx={{ width: "620px" }}>
                <ProductSection
                  getProductPickerInfo={getProductPickerInfo}
                  isView={isView}
                  {...slotProps?.product}
                />
              </Grid>
              <Grid
                item
                sx={{
                  width: "300px",
                  borderLeft: `1px solid ${theme.igBorders.core.default}`,
                }}
              >
                <SelectedProductSection
                  isView={isView}
                  experienceStatus={experienceStatus}
                  dialogActions={dialogActions}
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              wrap={"nowrap"}
              sx={{
                borderTop: `1px solid ${theme.igBorders.core.default}`,
                height: "66px",
                paddingX: 6,
                paddingY: 4,
              }}
            >
              <Grid item xs={8}>
                <IgTypography>{products.length} products selected</IgTypography>
              </Grid>
              {dialogActions && (
                <Grid
                  item
                  columnSpacing={3}
                  container
                  justifyContent={"flex-end"}
                  direction={"row"}
                >
                  {dialogActions.map((action, index) => (
                    <Grid item key={index}>
                      {action}
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          </>
        )}
      </Grid>
      {/*<Box*/}
      {/*  justifyContent={"space-between"}*/}
      {/*  sx={{*/}
      {/*    display: "flex",*/}
      {/*    padding: "40px",*/}
      {/*    alignItems: "stretch",*/}
      {/*    justifyContent: "stretch",*/}
      {/*    ...sx,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  {loadStatus === undefined && (*/}
      {/*    <>*/}
      {/*      <ProductSection*/}
      {/*        getProductPickerInfo={getProductPickerInfo}*/}
      {/*        isView={isView}*/}
      {/*        {...slotProps?.product}*/}
      {/*      />*/}
      {/*      <Box*/}
      {/*        sx={{*/}
      {/*          marginLeft: "20px",*/}
      {/*          width: "1px",*/}
      {/*          backgroundColor: "#eee",*/}
      {/*          marginRight: "20px",*/}
      {/*        }}*/}
      {/*      />*/}
      {/*      <SelectedProductSection*/}
      {/*        isView={isView}*/}
      {/*        experienceStatus={experienceStatus}*/}
      {/*        dialogActions={dialogActions}*/}
      {/*      />*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</Box>*/}
    </ProductPickerProvider>
  );
};
